import React from 'react';
import { BodyText, BoldBodyText, FlexRow, SmallBodyText } from 'ui-toolkit';
import { IPropertyAddressData, propertyAddressToString } from '../../../../../types/address/IPropertyAddressData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faLocationPin } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import {
  getSigningAppointmentDisplayDateTime,
  getSigningAppointmentPartyPurposeDisplayLabel,
  ISigningAppointmentResponse,
} from '../../../../../types/signingAppointment/ISigningAppointmentResponse';
import { AppointmentStatusBadge } from '../../../scheduling/Reusable/AppointmentStatusBadge';
import { ePartyPurpose } from '../../../../../ui-toolkit/enums/ePartyPurpose';

export interface ISigningAppointmentSummaryViewProps {
  appointment?: ISigningAppointmentResponse;
  partyType: ePartyPurpose;
}

export const SigningAppointmentSummaryView: React.FC<ISigningAppointmentSummaryViewProps> = ({
  appointment,
  partyType,
}) => {
  const showDateTime = appointment && (appointment.appointmentDate || appointment.appointmentTime);
  const showAddress =
    appointment &&
    appointment.address &&
    (appointment.address.streetAddress ||
      appointment.address.city ||
      appointment.address.unit ||
      appointment.address.zipCode ||
      appointment.address.stateAbbreviation);

  if (appointment === undefined || !appointment.id) {
    return <SmallBodyText intent={`faded`}>Not Scheduled</SmallBodyText>;
  }

  return (
    <div data-test-id={`appointment-summary-${appointment.id}`} className={'mt-2'}>
      <FlexRow justifyContent="space-between">
        <BoldBodyText>
          {getSigningAppointmentPartyPurposeDisplayLabel(appointment, partyType)}{' '}
          <AppointmentStatusBadge appointment={appointment} />
        </BoldBodyText>
      </FlexRow>
      <FlexRow>
        <div>
          {showDateTime && (
            <BodyText>
              <PrimaryFontAwesomeIcon icon={faCalendar} />
              &nbsp;
              {getSigningAppointmentDisplayDateTime(appointment)}
            </BodyText>
          )}
        </div>
      </FlexRow>
      {showAddress && (
        <FlexRow>
          <BodyText>
            <PrimaryFontAwesomeIcon icon={faLocationPin} />
            &nbsp;
            {propertyAddressToString(appointment.address as IPropertyAddressData)}
          </BodyText>
        </FlexRow>
      )}
    </div>
  );
};

const PrimaryFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.primary};
`;
